import { MoreVert as MoreVertIcon } from 'components/icons';
import { TableRowCallForActionButton } from 'components/buttons/CallForActionButton';
import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import { FormattedMessage } from 'react-intl';
import { t } from 'utils/getTranslations';

interface Props {
    matterId: number;
    onRemove: (matterId: number) => void;
}

const ProjectMatterActionButtons = ({ matterId, onRemove }: Props): JSX.Element => {
    const { openModal, closeModal } = useModal();

    const handleOpenRemoveModal = () =>
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    onRemove(matterId);
                    closeModal();
                }}
                content={<FormattedMessage id="projects.list-page.table.matter-actions.disconnect-case-confirmation" />}
            />,
            closeModal
        );

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <TableRowCallForActionButton shape="rounded" aria-label={t('actions')}>
                        <MoreVertIcon />
                    </TableRowCallForActionButton>
                }
            />
            <DropdownMenuContent align="end" className="w-auto">
                <DropdownMenuItem onClick={handleOpenRemoveModal}>
                    <FormattedMessage id="projects.list-page.table.matter-actions.disconnect-case" />
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default ProjectMatterActionButtons;
